import React, { useEffect, useState } from 'react'

import '../assets/main.css';
import '../assets/admin.css';

import Logo from '../assets/logos/logo.png'

import favIcon from '../assets/logos/favicon.png'
import { Link } from 'react-router-dom';
import { useChangePasswordMutation } from './store/ReduxApis';
import toast, { Toaster } from 'react-hot-toast';
import { useHistory } from 'react-router-dom';






function PasswordSettings() {
  const history = useHistory();
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [oldpassword, setOldPassword] = useState("")
  const [showPassword, setShowPassword] = useState(null);
  const [showOldPassword, setShowOldPassword] = useState(null);
  const [passwordError, setPasswordError] = useState("");
  const [oldPasswordError, setOldPasswordError] = useState("");

  const [createPost, responseInfo] = useChangePasswordMutation()

  const validatePassword = (password) => {
    const minLength = 8;
    let errorMessage = [];

    if (password.length < minLength) {
      errorMessage.push(`at least ${minLength} characters long`);
    }

    if (!/[A-Z]/.test(password)) {
      errorMessage.push("one uppercase letter");
    }

    if (!/[a-z]/.test(password)) {
      errorMessage.push("one lowercase letter");
    }

    if (!/[0-9]/.test(password)) {
      errorMessage.push("one number");
    }

    if (!/[!@#$%^&*]/.test(password)) {
      errorMessage.push("one special character (!@#$%^&*)");
    }

    if (errorMessage.length > 0) {
      return `Password should contain ${errorMessage.join(', ')}`;
    }

    return ""; // No error means password is valid
  };


  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    const errorMessage = validatePassword(value);
    setPasswordError(errorMessage); // Set error message if invalid
  };

  const newPost = {
    "oldpassword": oldpassword,
    "password": password
  }

  const token = async (e) => {
    e.preventDefault()

    // Check if old password is empty
    if (!oldpassword) {
      setOldPasswordError("Old password is required");
    } else {
      setOldPasswordError("");
    }

    // Check if new password is empty
    if (!password) {
      setPasswordError("New password is required");
      return;
    }

    // Validate new password strength
    const errorMessage = validatePassword(password);
    if (errorMessage) {
      setPasswordError(errorMessage);
      return;
    } else {
      setPasswordError("");
    }

    await createPost(newPost);
  }

  useEffect(() => {
    if (responseInfo?.data?.status === "success") {
      toast(responseInfo?.data?.message)
      localStorage.removeItem("nugenToken");
      // window.location.reload(false);
      setTimeout(() => {
        window.location.reload(false);
      }, 1500)
    } else if (responseInfo?.data?.status === "fail") {
      toast(responseInfo?.data?.message)
    }
  }, [responseInfo])

  console.log(responseInfo)

  return (

    <section className="content pages">
      <Toaster />

      <div className='mainPage'>
        <h3>Password Settings</h3>
      </div>
      <div className="row">
        <div className="firstBox" >
          <div className='box box-info'>


            <div className="box-header with-border">
              <h5 className="title">Manage Settings</h5>
            </div>

            <div className='icons'>
              <i class="fas fa-cog"></i>
              <li><Link className='link' to="/general">General</Link></li>
            </div>
            <div className='icons'>
              <i class="fas fa-lock"></i>
              <li><Link className='link' to="/emailSettings">Email Settings</Link></li>
            </div>
            <div className='icons'>
              <i class="fas fa-key"></i>
              <li><Link className='link' to="/moduleSettings">Module Settings</Link></li>
            </div>
            <div className='icons'>
              <i class="fas fa-cog"></i>
              <li><Link className='link' to="/email">Email Template Settings</Link></li>
            </div>
            <div className='icons'>
              <i class="fas fa-share-alt"></i>
              <li><Link className='link' to="/password">Password Settings</Link></li>
            </div>
            <div className='icons'>
              <i class="fas fa-cog"></i>
              <li><Link className='link' to="/account">Token Contribution Settings</Link></li>
            </div>
            <div className='icons'>
              <i class="fab fa-google"></i>
              <li><Link className='link' to="/contractAddress">Contract Address Settings</Link></li>
            </div>
            <div className='icons'>
              <i class="fas fa-key"></i>
              <li><Link className='link' to="/referral-bonus">Referral Bonus Distribution Setting</Link></li>
            </div>
            <div className='icons'>
              <i class="fab fa-google"></i>
              <li><Link className='link' to="/details">Admin Details</Link></li>
            </div>

            <div className='icons'>
              <i class="fas fa-cog"></i>
              <li><Link className='link' to="/status">Social Media Link</Link></li>
            </div>
            {/* <div className='icons'>
                      <i class="fas fa-bullhorn"></i>
          <li><Link className='link' to="/market">Market Wallet Transactions</Link></li>
                      </div>
                      <div className='icons'>
                      <i class="fas fa-key"></i>
          <li><Link className='link' to="/product">Product Wallet Transactions</Link></li>
                      </div>
                      <div className='icons'>
                      <i class="fab fa-dropbox"></i>
          <li><Link className='link' to="/airdrop">Airdrop Wallet Transactions</Link></li>
                      </div>
                      <div className='icons'>
                      <i class="fas fa-user-friends"></i>
          <li><Link className='link' to="/team">Team Wallet Status</Link></li>
                      </div>
                      <div className='icons'>
                      <i class="fas fa-anchor"></i>
          <li><Link className='link' to="/operation">Operation Wallet Status</Link></li>
                      </div> */}

          </div>
        </div>

        <div style={{ width: "60%" }} >
          <div className='box box-info'>
            <div className='box-header with-border'>
              <h5 className="title">Password Settings</h5>
            </div>

            <div className='setting'>
              {/* <div className="path">
                              <label>Email</label>
                              <input type="text" onChange={(e) => setEmail(e.target.value)} placeholder='Please Enter your email' style={{marginLeft: "30px"}}></input>
                          </div> */}

              <div className="path mb-1">
                <label>Old Password</label>
                <div className="input-container d-flex">
                  <input placeholder='please Enter a Old password' class="form-control"
                    type={showOldPassword ? 'text' : 'password'}
                    onChange={(e) => setOldPassword(e.target.value)}></input>

                  {/* <input formControlName="password" type={showPassword ? 'text' : 'password'} 
                     placeholder='please Enter a Old password'
                     onChange={(e) => setOldPassword(e.target.value)} class="form-control" 
                     /> */}

                  <div class="input-group-append">
                    <div class="input-group-text">
                      <span onClick={() => setShowOldPassword(!showOldPassword)} className="eyeic">
                        {!showOldPassword ? <i className="fas fa-eye-slash"></i> : <i class="fa fa-eye"></i>}
                      </span>

                    </div>
                  </div>
                </div>
              </div>
              {oldPasswordError && <p style={{ color: "red", textAlign: 'center' }}>{oldPasswordError}</p>}


              <div className="path mb-1">
                <label>New Password</label>
                <div className="input-container d-flex">
                  <input placeholder='please Enter a New password'
                    type={showPassword ? 'text' : 'password'}
                    class="form-control"
                    // onChange={(e) => setPassword(e.target.value)}
                    onChange={handlePasswordChange}
                  >

                  </input>
                  <div class="input-group-append">
                    <div class="input-group-text">
                      <span onClick={() => setShowPassword(!showPassword)} className="eyeic"> {!showPassword ? <i className="fas fa-eye-slash"></i> : <i class="fa fa-eye"></i>} </span>

                    </div>
                  </div>
                </div>
              </div >
              {passwordError && <p style={{ color: 'red', textAlign: 'center' }}>{passwordError}</p>}


            </div>
            <button className='btn btns' onClick={(e) => token(e)}>Submit</button>
          </div>


        </div>

      </div>

    </section>

  )
}

export default PasswordSettings